import type { CardType } from '../../payment.types';
import { CardPointeGatewayId } from './cardpointe/cardpointe-system-constants';
import { CloverGatewayId } from './clover/clover-system-constants';
import type { ValorGatewayTransactionDetails } from './valor/valor-payment.types';
import { ValorGatewayTransactionDetailsType } from './valor/valor-payment.types';

export const CardPointeGatewayTransactionDetailsType =
    'cardpointe_gateway_transaction_details' as const;

export interface CardPointeNormalizedGatewayTransactionDetails {
    readonly gateway_id: typeof CardPointeGatewayId;
    readonly gateway_transaction_details_type: typeof CardPointeGatewayTransactionDetailsType;
    readonly gateway_transaction_details_version: 1;
    readonly gateway_txn_id: string;
    readonly base_amount: number;
    readonly total_amount: number;
    readonly total_fee_amount: number;
    readonly total_tax_amount: number;
    readonly is_void: boolean;
    readonly is_settled: boolean;
    readonly refund_amount: number;
    readonly refund_count: number;
    readonly card_brand?: string;
    readonly card_last4?: string;
    readonly cardholder_name?: string;
    readonly card_type?: CardType;
    readonly settlement_status?: string;
    readonly authorization_code?: string;
    readonly batch_id?: string;
}

export const CloverGatewayTransactionDetailsType =
    'clover_gateway_transaction_details' as const;

export interface CloverNormalizedGatewayTransactionDetails {
    readonly gateway_id: typeof CloverGatewayId;
    readonly gateway_transaction_details_type: typeof CloverGatewayTransactionDetailsType;
    readonly gateway_transaction_details_version: 1;
    readonly gateway_txn_id: string;
    readonly base_amount: number;
    readonly total_amount: number;
    readonly total_fee_amount: number;
    readonly total_tax_amount: number;
    readonly is_void: boolean;
    readonly is_settled: boolean;
    readonly refund_amount: number;
    readonly refund_count: number;
    readonly card_brand?: string;
    readonly card_last4?: string;
    readonly cardholder_name?: string;
    readonly card_type?: CardType;
    readonly settlement_status?: string;
    readonly authorization_code?: string;
    readonly batch_id?: string;
}

export const IPG_GATEWAY_TRANSACTION_DETAILS_TYPE = {
    VALOR: ValorGatewayTransactionDetailsType,
    CARDPOINTE: CardPointeGatewayTransactionDetailsType,
    CLOVER: CloverGatewayTransactionDetailsType,
} as const;

export type IpgGatewayTransactionDetailsType =
    (typeof IPG_GATEWAY_TRANSACTION_DETAILS_TYPE)[keyof typeof IPG_GATEWAY_TRANSACTION_DETAILS_TYPE];

export type IpgGatewayTransactionDetails =
    | ValorGatewayTransactionDetails
    | CardPointeNormalizedGatewayTransactionDetails
    | CloverNormalizedGatewayTransactionDetails;

export function gatewayTransactionDetailsTypeRequiresBaseAmountMatch(
    detailsType: IpgGatewayTransactionDetailsType
): boolean {
    switch (detailsType) {
        case CloverGatewayTransactionDetailsType:
            return false;
        case CardPointeGatewayTransactionDetailsType:
        case ValorGatewayTransactionDetailsType:
            return true;
    }
}

export function gatewayTransactionTipAmount(
    details: IpgGatewayTransactionDetails
): number {
    switch (details.gateway_transaction_details_type) {
        case ValorGatewayTransactionDetailsType:
            switch (details.gateway_transaction_details_version) {
                case 1:
                    return 0;
                case 2:
                    return details.tip_amount;
            }
        case CardPointeGatewayTransactionDetailsType:
        case CloverGatewayTransactionDetailsType:
            return 0;
    }
}
